import { Switch, Route } from "wouter";
import { queryClient } from "@/lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { fetchCdnConfig } from "@/lib/imageUrl";
import { useEffect } from "react";
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import CustomerMenu from "@/pages/CustomerMenu";
import RestaurantDashboard from "@/pages/RestaurantDashboard";
import AdminPage from "@/pages/AdminPage";
import Subscribe from "@/pages/Subscribe";
import SubscribeSuccess from "@/pages/SubscribeSuccess";
import Terms from "@/pages/Terms";
import CustomerTerms from "@/pages/CustomerTerms";
import Receipt from "@/pages/Receipt";
import OrderTracking from "@/pages/OrderTracking";
import Landing from "@/pages/Landing";
import Products from "@/pages/Products";
import ThankYou from "@/pages/ThankYou";
import ReservationBooking from "@/pages/ReservationBooking";
import { NativeRelay } from "@/components/NativeRelay";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import type { Restaurant } from "@/shared/schema";


function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/menu/:id" component={CustomerMenu} />
      <Route path="/receipt/:orderId" component={Receipt} />
      <Route path="/track/:orderId" component={OrderTracking} />
      <Route path="/dashboard" component={RestaurantDashboard} />
      <Route path="/dashboard/:tab" component={RestaurantDashboard} />
      <Route path="/admin" component={AdminPage} />
      <Route path="/subscribe" component={Subscribe} />
      <Route path="/subscribe/success" component={SubscribeSuccess} />
      <Route path="/subscribe/success/" component={SubscribeSuccess} />
      <Route path="/terms" component={Terms} />
      <Route path="/customer-terms" component={CustomerTerms} />
      <Route path="/landing" component={Landing} />
      <Route path="/products" component={Products} />
      <Route path="/thank-you" component={ThankYou} />
      <Route path="/reserve/:restaurantId" component={ReservationBooking} />
      <Route component={NotFound} />
    </Switch>
  );
}

function AppContent() {
  const { user } = useAuth();
  const { data: restaurant } = useQuery<Restaurant>({
    queryKey: ['/api/restaurant'],
    enabled: !!user,
  });

  return (
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <NativeRelay restaurantId={restaurant?.id} />
        <Router />
      </TooltipProvider>
    </LanguageProvider>
  );
}

function App() {
  // Fetch CDN config on app startup (non-blocking)
  useEffect(() => {
    fetchCdnConfig().catch(console.error);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
    </QueryClientProvider>
  );
}

export default App;